export default {
  label: {
    security: '보안 템플릿',
  },
  buttonType: {
    WL: '웹링크',
    AL: '앱링크',
    AC: '채널추가',
    DS: '배송조회',
  },
  comment: {
    security: '※ 해당 메시지는 메인 디바이스 모바일에서만 내용을 볼 수 있습니다.',
  },
  placeholder: {
    content: '템플릿을 불러오면 내용이 입력됩니다.',
    customerSetting: '※ 템플릿에 등록되어 있는 변수를 변경할 수 있습니다.',
  },
  preview: {
    head: '알림톡 도착',
  },
};
